import styled from 'styled-components';
import chartImage from './img/graph.png';

export const ChartImage = styled.img`
	margin-top: 27px;
	width: 100%;
	height: auto;
`;

ChartImage.defaultProps = {
	src: chartImage,
	alt: 'chart',
};
